export default __webpack_public_path__ + "static/media/watchlist.5304e091.svg";